import { Authentication, FlagsmithIdentityInit } from '@core/components';
import { Authorization } from '@core/components/Auth/Authorization';
import { environment } from '@core/environment';
import { store } from '@core/redux/store';
import { darkTheme } from '@deepup/mui-theme-deepup';
import { Provider } from 'react-redux';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Settings } from 'luxon';
import flagsmith from '@flagsmith/flagsmith';
import { FlagsmithProvider } from '@flagsmith/flagsmith/react';
import { Router } from './Router';

const { flagsmithEnvId } = environment;

Settings.defaultLocale = 'en'; // Set global locale

export const App = () => (
  <FlagsmithProvider flagsmith={flagsmith} options={{ environmentID: flagsmithEnvId }}>
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <Provider store={store}>
        <ThemeProvider theme={darkTheme}>
          <CssBaseline />
          <Authentication>
            <FlagsmithIdentityInit>
              <Authorization>
                <Router />
              </Authorization>
            </FlagsmithIdentityInit>
          </Authentication>
        </ThemeProvider>
      </Provider>
    </LocalizationProvider>
  </FlagsmithProvider>
);
